/* eslint-disable max-lines-per-function */
import { VueTeleport } from "common/vue/VueTeleport";
import { VueTransitionGroup } from "common/vue/VueTransitionGroup";
import { renderList } from "common/vue/render-list";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { cn } from "tailwind-variants";
import "./PinningToast.scss";

function PinningToast({ toasts, onDismiss, ...restProps }) {
  return (
    <VueTeleport
      {...restProps}
      className={cn("scope-ec47d4b5", restProps.className)}
      to="body"
      data-testid="teleport"
    >
      <div
        className="scope-ec47d4b5 pointer-events-none fixed bottom-0 right-0 z-[2147483100] flex w-full max-w-[420px] flex-col gap-2 p-4"
        data-testid="pinning-toast-region"
      >
        <VueTransitionGroup
          className="scope-ec47d4b5"
          name="pinning-toast"
          data-testid="transition-group"
        >
          {renderList(toasts, toast => (
            <div
              className={cn(
                "scope-ec47d4b5 pointer-events-auto relative flex w-full items-start gap-3 overflow-hidden rounded-md border border-slate-700 bg-slate-800 p-4 pr-10 text-white shadow-lg",
                toast.removing && "translate-x-4 opacity-0"
              )}
              key={toast.id}
              data-testid="pinning-toast-item"
            >
              {}
              {toast.variant === "error" ? (
                <UseSvg
                  className="scope-ec47d4b5 mt-0.5 h-5 w-5 shrink-0 text-red-400"
                  icon="alert-circle"
                  data-testid="mt-0.5"
                />
              ) : toast.variant === "success" ? (
                <UseSvg
                  className="scope-ec47d4b5 mt-0.5 h-5 w-5 shrink-0 text-green-400"
                  icon="check-circle"
                  data-testid="mt-0.5-1"
                />
              ) : toast.variant === "warning" ? (
                <UseSvg
                  className="scope-ec47d4b5 mt-0.5 h-5 w-5 shrink-0 text-yellow-400"
                  icon="alert-triangle"
                  data-testid="mt-0.5-2"
                />
              ) : (
                <UseSvg
                  className="scope-ec47d4b5 mt-0.5 h-5 w-5 shrink-0 text-blue-400"
                  icon="info-circle-thin"
                  data-testid="mt-0.5-3"
                />
              )}
              {}
              <div className="scope-ec47d4b5 flex-1">
                <div className="scope-ec47d4b5 font-medium text-white">{toast.title}</div>
                {toast.description ? (
                  <div className="scope-ec47d4b5 mt-0.5 text-sm text-gray-300">
                    {toast.description}
                  </div>
                ) : null}
              </div>
              {}
              <button
                className="scope-ec47d4b5 absolute right-2 top-2 cursor-pointer rounded-full border-none bg-transparent p-1 text-white hover:bg-slate-700"
                type="button"
                aria-label="Close toast"
                data-testid="pinning-toast-close"
                onClick={() => {
                  onDismiss?.(toast.id);
                }}
              >
                <UseSvg className="scope-ec47d4b5 h-4 w-4" icon="cross" data-testid="h-4" />
              </button>
            </div>
          ))}
        </VueTransitionGroup>
      </div>
    </VueTeleport>
  );
}

export default PinningToast;
